import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationCandidateIdsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationCandidateIdsController.php
* @route '/api/batch-operations/candidates/ids'
*/
const GetBatchOperationCandidateIdsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetBatchOperationCandidateIdsController.url(options),
    method: 'post',
})

GetBatchOperationCandidateIdsController.definition = {
    methods: ["post"],
    url: '/api/batch-operations/candidates/ids',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationCandidateIdsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationCandidateIdsController.php
* @route '/api/batch-operations/candidates/ids'
*/
GetBatchOperationCandidateIdsController.url = (options?: RouteQueryOptions) => {
    return GetBatchOperationCandidateIdsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationCandidateIdsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationCandidateIdsController.php
* @route '/api/batch-operations/candidates/ids'
*/
GetBatchOperationCandidateIdsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetBatchOperationCandidateIdsController.url(options),
    method: 'post',
})

export default GetBatchOperationCandidateIdsController